import {Grid} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loader () {
    return <Grid container justifyContent={"center"} alignItems={"center"} height={"60vh"}>
        <CircularProgress color={"inherit"} />
    </Grid>
}
